import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { isModuleEnabled } from "@/lib/modules";

export const Route = createFileRoute("/_authorized/team")({
	beforeLoad: ({ location }) => {
		// Multi-team-only routes when team module is off; personal workspace keeps /team/* URLs.
		if (!isModuleEnabled("team")) {
			const multiTeamOnly = ["/team/members", "/user/teams"];
			if (multiTeamOnly.some((path) => location.pathname.startsWith(path))) {
				throw redirect({ to: "/dashboard" });
			}
		}
	},
	component: () => <Outlet />,
});
